export function normalizeApiEnvelope(input) {
  const payload = input?.data && (input.status || input.statusText)
    ? input.data
    : input;

  const ok = payload?.ok === true || payload?.status === "OK";
  const errorValue = payload?.error || payload?.errors || "Error de servidor";

  return {
    ok,
    data: payload?.data,
    error: Array.isArray(errorValue) ? errorValue.join(", ") : errorValue,
    raw: payload,
  };
}
